import { AUTH_ENDPOINTS } from "./auth";
import { CREDENTIALS_ENDPOINTS } from "./credentials";
import { LOAD_TEST_ENDPOINTS } from "./load-test";
import { SERVERS_ENDPOINTS } from "./servers";
import { USER_ENDPOINTS } from "./user";

export const AUTOMATION_ENDPOINTS = {
  auth: AUTH_ENDPOINTS,
  user: USER_ENDPOINTS,
  credentials: CREDENTIALS_ENDPOINTS,
  servers: SERVERS_ENDPOINTS,
  load_test: LOAD_TEST_ENDPOINTS,
}